import lodash from "lodash";
import {
    createFieldDate,
    createFieldDatetime,
    createFieldInput,
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldTreeSelect
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callUser } from "../../../storage-location/request/requestor/requestor.section";
import { callCountry } from "../../../haz/request/haz-info/haz-info.section";
import { callTransportByWay } from "../../../inform/request/inform-info/inform-info.section";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });
export const callCustoms = ({ searchQuery }) => {
    const where = [{ name: "isActive", type: "Boolean", operator: "=", value: true }];
    if (searchQuery) {
        where.push(
            { openBucket: true, name: "name", type: "String", operator: "like", value: searchQuery },
            { logic: "OR", closeBucket: true, name: "code", type: "String", operator: "like", value: searchQuery }
        );
    }
    return store
        .dispatch("resource/v1/master/customs/search", {
            criteria: {
                isDistinct: true,
                select: ["*"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "name", type: "ASC" }]
            }
        })
        .then(page => page.data);
};

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.importExportDate`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.inspection.labels.importExportDate")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.importExportDate,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}transportDate`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.inspection.transportDate")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.transportDate,
                                        "onUpdate:value": value => (model.transportDate = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}approveCode`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.inspection.refInformTemp")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.approveCode,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldDatetime({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}inspectionDatetime`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => `${i18n.global.t("model.inspection.inspectionDatetime")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.inspectionDatetime,
                                        "onUpdate:value": value => (model.inspectionDatetime = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInspector`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inspection.refInspector"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInspector,
                                        "onUpdate:value": value => (model.refInspector = value),
                                        disabled: viewOnly,
                                        list: ({ searchQuery }) => callUser({ searchQuery, userCompanyId: model.refUserCompany.id }),
                                        renderLabel: ({ item }) => {
                                            if (item.refPersonType?.key === "1") {
                                                return <div>{item.companyNameTh}</div>;
                                            }
                                            return <div>{item.fullNameTh}</div>;
                                        },
                                        allowClear: false
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInspector.idCard`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.idCard"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInspector?.idCard,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}inspectorTel`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inspection.inspectorTel"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.inspectorTel,
                                        "onUpdate:value": value => (model.inspectorTel = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInspector.email`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.user.email"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInspector?.email,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        })
                    ],
                    skeleton: isLoading.value
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div class="mt-3"></div>
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refTransportByWay`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refTransportByWay"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refTransportByWay,
                                        "onUpdate:value": value => (model.refInformTemp.refTransportByWay = value),
                                        disabled: true,
                                        list: callTransportByWay,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div></div>
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refOriginDestinationCountry`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () =>
                                `${i18n.global.t("views.request.informInfo.country", {
                                    text:
                                        model.refRequestDoc?.key === "16"
                                            ? i18n.global.t("views.request.informInfo.source")
                                            : i18n.global.t("views.request.informInfo.desc")
                                })}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refOriginDestinationCountry,
                                        "onUpdate:value": value => (model.refInformTemp.refOriginDestinationCountry = value),
                                        disabled: true,
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                {item.nameEnS} : {item.nameTh}
                                            </span>
                                        )
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refExportCheckpoint`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refExportCheckpoint"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refExportCheckpoint,
                                        "onUpdate:value": value => (model.refInformTemp.refExportCheckpoint = value),
                                        disabled: true,
                                        list: callDepartment,
                                        renderLabel: ({ item }) => (
                                            <div>
                                                {item.fullCode} : {item.nameTh}
                                            </div>
                                        ),
                                        filterWhere: ({ value }) => [
                                            { name: "fullCode", operator: "like", value },
                                            { logic: "OR", name: "nameTh", operator: "like", value }
                                        ],
                                        treeDefaultExpandAll: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refImportCheckpoint`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => model.refInformTemp?.refOperation?.key === "2" ? i18n.global.t("model.inform.refImportCheckpoint2") : i18n.global.t("model.inform.refImportCheckpoint"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refImportCheckpoint,
                                        "onUpdate:value": value => (model.refInformTemp.refImportCheckpoint = value),
                                        disabled: true,
                                        list: callDepartment,
                                        renderLabel: ({ item }) => (
                                            <div>
                                                {item.fullCode} : {item.nameTh}
                                            </div>
                                        ),
                                        filterWhere: ({ value }) => [
                                            { name: "fullCode", operator: "like", value },
                                            { logic: "OR", name: "nameTh", operator: "like", value }
                                        ],
                                        treeDefaultExpandAll: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div></div>
                        },
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refPassCustoms`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => model.refInformTemp?.refOperation?.key === "2" ? i18n.global.t("model.inform.refPassCustoms2") : i18n.global.t("model.inform.refPassCustoms"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refPassCustoms,
                                        "onUpdate:value": value => (model.refInformTemp.refPassCustoms = value),
                                        disabled: true,
                                        list: () => callCustoms({}),
                                        optLabel: "name"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        {
                            visible: () => ['18', '19'].includes(model.refRequestDoc?.key),
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div>
                                <hr></hr>
                                <div className="mt-3">{i18n.global.t("views.request.pass.titleOut")}</div>
                            </div>
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refTransportByWay2`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refTransportByWay2"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refTransportByWay2,
                                        "onUpdate:value": value => (model.refInformTemp.refTransportByWay2 = value),
                                        disabled: true,
                                        list: callTransportByWay,
                                        optLabel: "value"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                        }),
                        {
                            visible: () => ['18', '19'].includes(model.refRequestDoc?.key),
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div></div>
                        },
                        createFieldSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refOriginDestinationCountry2`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () =>
                                `${i18n.global.t("views.request.informInfo.country", {
                                    text:
                                        model.refRequestDoc?.key === "16"
                                            ? i18n.global.t("views.request.informInfo.source")
                                            : i18n.global.t("views.request.informInfo.desc")
                                })}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refOriginDestinationCountry2,
                                        "onUpdate:value": value => (model.refInformTemp.refOriginDestinationCountry2 = value),
                                        disabled: true,
                                        list: callCountry,
                                        renderLabel: ({ item }) => (
                                            <span>
                                                {item.nameEnS} : {item.nameTh}
                                            </span>
                                        )
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) }
                        }),
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refExportCheckpoint2`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refExportCheckpoint2"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refExportCheckpoint2,
                                        "onUpdate:value": value => (model.refInformTemp.refExportCheckpoint2 = value),
                                        disabled: true,
                                        list: callDepartment,
                                        renderLabel: ({ item }) => (
                                            <div>
                                                {item.fullCode} : {item.nameTh}
                                            </div>
                                        ),
                                        filterWhere: ({ value }) => [
                                            { name: "fullCode", operator: "like", value },
                                            { logic: "OR", name: "nameTh", operator: "like", value }
                                        ],
                                        treeDefaultExpandAll: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refImportCheckpoint2`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refImportCheckpoint2"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refImportCheckpoint2,
                                        "onUpdate:value": value => (model.refInformTemp.refImportCheckpoint2 = value),
                                        disabled: true,
                                        list: callDepartment,
                                        renderLabel: ({ item }) => (
                                            <div>
                                                {item.fullCode} : {item.nameTh}
                                            </div>
                                        ),
                                        filterWhere: ({ value }) => [
                                            { name: "fullCode", operator: "like", value },
                                            { logic: "OR", name: "nameTh", operator: "like", value }
                                        ],
                                        treeDefaultExpandAll: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        {
                            visible: () => ['18', '19'].includes(model.refRequestDoc?.key),
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div></div>
                        },
                        createFieldTreeSelect({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refPassCustoms2`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.refPassCustoms2"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refPassCustoms2,
                                        "onUpdate:value": value => (model.refInformTemp.refPassCustoms2 = value),
                                        disabled: true,
                                        list: () => callCustoms({}),
                                        optLabel: "name"
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ]
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div class="mt-3">{i18n.global.t("views.request.inspectionInfo.referDoc")}</div>
                        },
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}vehicleNo`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inspection.vehicleNo"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.vehicleNo,
                                        "onUpdate:value": value => (model.vehicleNo = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}containerNo`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inspection.containerNo"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.containerNo,
                                        "onUpdate:value": value => (model.containerNo = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}sealNo`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inspection.sealNo"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.sealNo,
                                        "onUpdate:value": value => (model.sealNo = value),
                                        disabled: viewOnly
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ]
                })
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: [
                        {
                            visible: () => true,
                            colProp: () => ({ xs: 24 }),
                            formItemRender: () => <div class="mt-3">{i18n.global.t("views.request.inspectionInfo.transportDoc")}
                                {model.refInformTemp?.refTransferDeclaration?.declarationNumber ? `: ${model.refInformTemp?.refTransferDeclaration?.declarationNumber}` : ''}
                                {model.refInformTemp?.refTransferDeclaration?.referenceNumber ? ` / ${model.refInformTemp?.refTransferDeclaration?.referenceNumber}` : ''}
                            </div>
                        },
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refTransferDeclaration.vehicleNo`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.vehicleNo"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refTransferDeclaration?.vehicleNo,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                        createFieldInput({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refInformTemp.refTransferDeclaration.containerNo`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.inform.containerNo"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refInformTemp?.refTransferDeclaration?.containerNo,
                                        disabled: true
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                )
                        }),
                    ]
                })
            })
        ]
    });
};
